
import { Component, Mixins } from "vue-property-decorator";
import { IHistoryRecord, IObjectNameIdentifier } from "../../../../../../documaker/domain/format/objects";
import { INameHistoriesPropertyEditable, instanceOfINameHistoriesPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class NameHistoriesPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: INameHistoriesPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: INameHistoriesPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isNameHistoriesEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfINameHistoriesPropertyEditable(s) && s.nameHistories().isEditable(), false);
  }

  get nameHistories(): IHistoryRecord<IObjectNameIdentifier>[] {
    return this.readPropertyOrDefault(s => s.nameHistories().getValue(), []);
  }

  set nameHistories(value: IHistoryRecord<IObjectNameIdentifier>[]) {
    this.writePropertyWhenValid(s => s.nameHistories().setValue(value));
  }
}
